import { render, staticRenderFns } from "./ProductComplimentCard.vue?vue&type=template&id=77cb6dca&scoped=true&"
import script from "./ProductComplimentCard.vue?vue&type=script&lang=js&"
export * from "./ProductComplimentCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductComplimentCard.vue?vue&type=style&index=0&id=77cb6dca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb6dca",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
